var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-layout",
            { staticClass: "mt-4 mx-3", attrs: { row: "", wrap: "" } },
            [
              _c(
                "div",
                { attrs: { align: "left" } },
                [
                  _c("v-flex", { attrs: { md12: "" } }, [
                    _c("h2", { staticClass: "h2_title" }, [
                      _vm._v("Ingreso de Datos Sertec")
                    ])
                  ])
                ],
                1
              )
            ]
          ),
          _c("v-divider"),
          _c("br"),
          _vm.showForm
            ? _c(
                "v-form",
                {
                  staticClass: "mx-3",
                  attrs: { "lazy-validation": "" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.handleSubmit($event)
                    }
                  },
                  model: {
                    value: _vm.validForm,
                    callback: function($$v) {
                      _vm.validForm = $$v
                    },
                    expression: "validForm"
                  }
                },
                [
                  _c(
                    "v-layout",
                    [
                      _c(
                        "v-flex",
                        {
                          staticClass: "pa-1 mx-3",
                          attrs: { cols: "12", md5: "" }
                        },
                        [
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|max:15",
                                expression: "'required|max:15'"
                              }
                            ],
                            attrs: {
                              name: "caso",
                              "data-vv-name": "caso",
                              counter: 15,
                              label: "N° caso",
                              "error-messages": _vm.errors.collect("caso"),
                              required: ""
                            },
                            model: {
                              value: _vm.datosSertec.nro_caso,
                              callback: function($$v) {
                                _vm.$set(_vm.datosSertec, "nro_caso", $$v)
                              },
                              expression: "datosSertec.nro_caso"
                            }
                          }),
                          _c("v-select", {
                            attrs: {
                              name: "transportista",
                              "error-messages": _vm.errors.collect(
                                "transportista"
                              ),
                              label: "Transportista",
                              items: _vm.datosSertecDropdown.DDTransportistas
                            },
                            model: {
                              value: _vm.datosSertec.transportista,
                              callback: function($$v) {
                                _vm.$set(_vm.datosSertec, "transportista", $$v)
                              },
                              expression: "datosSertec.transportista"
                            }
                          }),
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              name: "planta",
                              "error-messages": _vm.errors.collect("planta"),
                              label: "Planta",
                              items: _vm.datosSertecDropdown.DDPlanta
                            },
                            model: {
                              value: _vm.datosSertec.planta,
                              callback: function($$v) {
                                _vm.$set(_vm.datosSertec, "planta", $$v)
                              },
                              expression: "datosSertec.planta"
                            }
                          }),
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              label: "Patente",
                              name: "patente",
                              "error-messages": _vm.errors.collect("patente"),
                              required: ""
                            },
                            model: {
                              value: _vm.datosSertec.patente,
                              callback: function($$v) {
                                _vm.$set(_vm.datosSertec, "patente", $$v)
                              },
                              expression: "datosSertec.patente"
                            }
                          }),
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              label: "Producto",
                              name: "produc",
                              "error-messages": _vm.errors.collect("produc"),
                              items: _vm.datosSertecDropdown.DDProducto
                            },
                            model: {
                              value: _vm.datosSertec.producto,
                              callback: function($$v) {
                                _vm.$set(_vm.datosSertec, "producto", $$v)
                              },
                              expression: "datosSertec.producto"
                            }
                          }),
                          _c(
                            "div",
                            {
                              staticClass: "ma-6",
                              attrs: { required: "" },
                              on: {
                                click: function($event) {
                                  return _vm.getDataPiker(0)
                                }
                              }
                            },
                            [
                              _c("v-combobox", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: "Fecha Origen Falla",
                                  name: "fechaOrigen",
                                  "error-messages": _vm.errors.collect(
                                    "fechaOrigen"
                                  ),
                                  "prepend-icon": "event",
                                  required: "",
                                  chips: "",
                                  readonly: "",
                                  "deletable-chips": ""
                                },
                                model: {
                                  value: _vm.datosSertec.fecha_origen_falla,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.datosSertec,
                                      "fecha_origen_falla",
                                      $$v
                                    )
                                  },
                                  expression: "datosSertec.fecha_origen_falla"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "ma-6",
                              attrs: { required: "" },
                              on: {
                                click: function($event) {
                                  return _vm.getDataPiker(1)
                                }
                              }
                            },
                            [
                              _c("v-combobox", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: "Fecha Apertura Ticket ",
                                  name: "fechaApertura",
                                  "error-messages": _vm.errors.collect(
                                    "fechaApertura"
                                  ),
                                  "prepend-icon": "event",
                                  required: "",
                                  chips: "",
                                  readonly: "",
                                  "deletable-chips": ""
                                },
                                model: {
                                  value: _vm.datosSertec.fecha_apertura_ticket,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.datosSertec,
                                      "fecha_apertura_ticket",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "datosSertec.fecha_apertura_ticket"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        {
                          staticClass: "pa-1 ma-3",
                          attrs: { cols: "12", md5: "" }
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass: "ma-6",
                              attrs: { required: "" },
                              on: {
                                click: function($event) {
                                  return _vm.getDataPiker(2)
                                }
                              }
                            },
                            [
                              _c("v-combobox", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: "Fecha Coordinación Trabajos",
                                  name: "fechaApertura",
                                  "error-messages": _vm.errors.collect(
                                    "fechaApertura"
                                  ),
                                  "prepend-icon": "event",
                                  required: "",
                                  chips: "",
                                  readonly: "",
                                  "deletable-chips": ""
                                },
                                model: {
                                  value:
                                    _vm.datosSertec.fecha_coordinacion_trabajos,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.datosSertec,
                                      "fecha_coordinacion_trabajos",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "datosSertec.fecha_coordinacion_trabajos"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "ma-6",
                              attrs: { required: "" },
                              on: {
                                click: function($event) {
                                  return _vm.getDataPiker(3)
                                }
                              }
                            },
                            [
                              _c("v-combobox", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                attrs: {
                                  label: "Fecha Solución Definitiva ",
                                  name: "fechaSolucion",
                                  "error-messages": _vm.errors.collect(
                                    "fechaSolucion"
                                  ),
                                  "prepend-icon": "event",
                                  required: "",
                                  chips: "",
                                  readonly: "",
                                  "deletable-chips": ""
                                },
                                model: {
                                  value:
                                    _vm.datosSertec.fecha_solucion_definitiva,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.datosSertec,
                                      "fecha_solucion_definitiva",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "datosSertec.fecha_solucion_definitiva"
                                }
                              })
                            ],
                            1
                          ),
                          _c("v-text-field", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|numeric",
                                expression: "'required|numeric'"
                              }
                            ],
                            attrs: {
                              "data-vv-name": "diasSolucion",
                              label: "Días de Solución",
                              type: "numeric",
                              "error-messages": _vm.errors.collect(
                                "diasSolucion"
                              ),
                              required: ""
                            },
                            model: {
                              value: _vm.datosSertec.horas_o_dias_en_solucion,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.datosSertec,
                                  "horas_o_dias_en_solucion",
                                  $$v
                                )
                              },
                              expression: "datosSertec.horas_o_dias_en_solucion"
                            }
                          }),
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|alpha_spaces",
                                expression: "'required|alpha_spaces'"
                              }
                            ],
                            attrs: {
                              label: "Estado Solicitud",
                              name: "estado",
                              "error-messages": _vm.errors.collect("estado"),
                              required: "",
                              items: _vm.datosSertecDropdown.DDEstado
                            },
                            model: {
                              value: _vm.datosSertec.estado,
                              callback: function($$v) {
                                _vm.$set(_vm.datosSertec, "estado", $$v)
                              },
                              expression: "datosSertec.estado"
                            }
                          }),
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|alpha_spaces",
                                expression: "'required|alpha_spaces'"
                              }
                            ],
                            attrs: {
                              label: "Motivo Rechazo",
                              name: "motivo",
                              items: _vm.datosSertecDropdown.DDMotivoRehazo
                            },
                            model: {
                              value: _vm.datosSertec.motivo_rechazo,
                              callback: function($$v) {
                                _vm.$set(_vm.datosSertec, "motivo_rechazo", $$v)
                              },
                              expression: "datosSertec.motivo_rechazo"
                            }
                          }),
                          _c("v-select", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required|alpha_spaces",
                                expression: "'required|alpha_spaces'"
                              }
                            ],
                            attrs: {
                              label: "Tipo de Soporte",
                              "error-messages": _vm.errors.collect(
                                "tipoSoporte"
                              ),
                              name: "tipoSoporte",
                              items: _vm.datosSertecDropdown.DDTipoSoporte
                            },
                            model: {
                              value: _vm.datosSertec.tipo_caso,
                              callback: function($$v) {
                                _vm.$set(_vm.datosSertec, "tipo_caso", $$v)
                              },
                              expression: "datosSertec.tipo_caso"
                            }
                          }),
                          _c("v-textarea", {
                            directives: [
                              {
                                name: "validate",
                                rawName: "v-validate",
                                value: "required",
                                expression: "'required'"
                              }
                            ],
                            attrs: {
                              rows: "4",
                              label: "Comentario de Trabajo",
                              name: "comentario",
                              "error-messages": _vm.errors.collect(
                                "comentario"
                              ),
                              required: ""
                            },
                            model: {
                              value: _vm.datosSertec.comentario,
                              callback: function($$v) {
                                _vm.$set(_vm.datosSertec, "comentario", $$v)
                              },
                              expression: "datosSertec.comentario"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        {
                          staticClass: "pa-1 ma-3",
                          attrs: { cols: "12", md2: "" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "#27488E",
                                dark: "",
                                type: "submit"
                              }
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    this.acciones[this.accionSeleccionada]
                                  ) +
                                  "\n          "
                              )
                            ]
                          ),
                          _vm.accionSeleccionada == 1
                            ? _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "#27488E",
                                    dark: "",
                                    outline: ""
                                  },
                                  on: { click: _vm.cancelar }
                                },
                                [_vm._v("\n            cancelar\n          ")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "290" },
              model: {
                value: _vm.dateStartDialog,
                callback: function($$v) {
                  _vm.dateStartDialog = $$v
                },
                expression: "dateStartDialog"
              }
            },
            [
              _c("v-date-picker", {
                attrs: {
                  min: _vm.minDate,
                  range: "",
                  "event-color": "#27488E"
                },
                on: {
                  change: function($event) {
                    return _vm.dateSeleccionFin()
                  }
                },
                model: {
                  value: _vm.dateSelected,
                  callback: function($$v) {
                    _vm.dateSelected = $$v
                  },
                  expression: "dateSelected"
                }
              })
            ],
            1
          ),
          _c("GridSertec", { ref: "grilla" })
        ],
        1
      ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacionClose,
          titulo: _vm.$t("mensajes.mensajesAbandono.editar.titulo"),
          mensaje: _vm.$t("mensajes.mensajesAbandono.editar.mensaje"),
          textoBtnSi: _vm.$t("mensajes.mensajesAbandono.editar.btnAceptar"),
          textoBtnNo: _vm.$t("mensajes.mensajesAbandono.editar.btnCancelar")
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallbackConfirm($event, false)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }